<template>
  <section>
    <b-modal id="vendor-offer-details" size="sm" ok-title="Send Email" @ok="onEmailOffer" hide-header>
      <h6 v-html="contactDetails" />
    </b-modal>
    <send-emails
      :sendEmailData="sendEmailData"
      :modalId="modalId"
    ></send-emails>
  </section>
</template>

<script>
import SendEmails from '@/shared/components/SendEmails';

export default {
  components: {
    SendEmails
  },
  props: {
    offer: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      sendEmailData: {},
      modalId: 'quick-send-offer-email'
    }
  },
  computed: {
    contactDetails() {
      return `<dl><dt>Company:</dt><dd><t></t> ${this.offer.companyName}</dd>
            <dt>Contact:</dt><dd>${this.offer.contactFullName}</dd>
            <dt>Email:</dt><dd>${this.offer.contactEmail}</dd>
         <dt>Phone:</dt><dd>${this.offer.contactPhone}</dd></dl>`;
    }
  },
  methods: {
    async onEmailOffer($event) {
      let emailBody = `Hi ${this.offer.contactFullName},
        We would like to request for a price update with the following part:`
      if (this.offer.partNumber) emailBody += `<strong>Part:</strong> ${this.offer.partNumber}`
      if (this.offer.description) emailBody += `<strong>Description:</strong> ${this.offer.description}`     
      if (this.offer.mfr) emailBody += `<strong>Mfr:</strong> ${this.offer.mfr}`
      if (this.offer.quantity) emailBody += `<strong>Quantity:</strong> ${this.offer.quantity}` 
      // if (this.offer.)
      if (this.offer.dateCode) emailBody += `<strong>Date Code:</strong> ${this.offer.dateCode}`
      if (this.offer.lotCode) emailBody += `<strong>Lot Code:</strong> ${this.offer.lotCode}`
      if (this.offer.revision) emailBody += `<strong>Revision:</strong> ${this.offer.revision}`
      if (this.offer.conditionName) emailBody += `<strong>Condition:</strong> ${this.offer.conditionName}`
      if (this.offer.countryOfOriginName) emailBody += `<strong>COO:</strong> ${this.offer.countryOfOriginName}`

      emailBody += `<br/> Regards, <strong>Aegis Components</strong>`

      this.sendEmailData = {
        to: this.offer.contactEmail,
        ReferenceId: this.offer.id,
        subject: 'Request for Price Update Quotation',
        body: emailBody
        
      };

      this.$root.$emit('bv::show::modal', this.modalId);
    },
  }
}
</script>

<style>
#vendor-offer-details .modal-dialog {
  max-width: 350px !important;
}

</style>